import React from "react";
import { connect } from "react-redux";
import UsersCard from "./UsersCard";
import AddIcon from "../UIComponents/AddIcon";
import { getMMPLUsersList, DeleteMMPLUser } from "../Actions/UserManagementAPI";
import axios from "axios";
import API from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Role from "../helpers/role";

import { toast } from "react-toastify";
const searchData = {
  Mail: "",
  IsAdmin: false,
  PageNumber: 1,
  PageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");
let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Mail: "",
        IsAdmin: false,
        PageNumber: 1,
        PageSize: 25,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchData = this.SearchData.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: "SubBannerTitle", data: "MMPL User Management" });
    this.props.dispatch(getMMPLUsersList(this.state.searchData));
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  SearchData(Pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(getMMPLUsersList(this.state.searchData));
  }

  eyeclick(item) {
    const { history } = this.props;
    history.push(`/Home/Management/EditUser/${item.userId}`);
  }

  DeleteUserData(item) {
    const { dispatch } = this.props;
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let user = {
              userId: item.mmplId,
              email: item.mail,
              name: item.name,
              isDeleted: true,
              isAdmin: item.isAdmin,
              mmplShips: "",
              phone: "",
              modifiedBy: currentuser.name
            };
            let url = `${API.UpdateMmplUser}`;
            axios.put(url, user, {
              headers: {
                key: currentuser.accessToken,
              },
            })
              .then((response) => {
                dispatch(getMMPLUsersList(searchData));
                dispatch({
                  type: "DeleteUserSuccess",
                  data: response.data
                })
                toast.success('Deleted Successfully', {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });

              })
              .catch((error) => {
                dispatch({
                  type: "DeleteUserFailure",
                  error: "ERROR"
                })
              })
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
      overlayClassName: 'custom-alert'
    });
  }

  // DeleteUserData(item) {
  //   this.props.dispatch(DeleteMMPLUser(item.userId));
  // }

  ClearInput() {
    this.state.searchData.Mail = "";
    this.props.dispatch(getMMPLUsersList(this.state.searchData));
    this.setState({});
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { showSidePane, UsersList } = this.props;

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className=" card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      MMPL User Management
                    </h5>
                    {userRole == Role.mmpl ? (<></>) : (<>
                      <div
                        className="m-1 flex"
                        onClick={() => this.AddUser()}
                      >
                        <span className="card-title m-auto">Add User</span>
                        <AddIcon />
                      </div>
                    </>)}
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-3">
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-6 "}
                    >
                      <label className="form-label">Email</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="Mail"
                        placeholder="Email"
                        value={this.state.searchData.Mail}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6" : "col-lg-6"}>
                      <label className="mt-4"></label>
                      <br></br>
                      <div
                        className="search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SearchData(1)}
                        >
                          {" "}
                          Search{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ClearInput()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {UsersList ? (
            <UsersCard
              arraylist={UsersList.data}
              pageSize={UsersList.pagination.pageSize}
              totalRecords={
                UsersList.pagination.totalcount
                  ? UsersList.pagination.totalcount
                  : 0
              }
              DeleteUser={(item) => this.DeleteUserData(item)}
              eyeclick={(item) => this.eyeclick(item)}
              setUpdatedState={(value) => this.SearchData(value)}
            />
          ) : null}
        </div>
      </div>
    );
  }

  AddUser = () => {
    this.props.history.push(`/Home/Management/AddUser`);
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    UsersList: state.UserManageReducer.UsersList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
